
import { IInlineSearchGetters } from '@/interfaces/getters.interface';
import state from './state';
import { IProgrammeResult } from '@studyportals/search-api-interface';
import { IProgrammeCard } from '@studyportals/domain-client';


const getters: IInlineSearchGetters = {
	amIVisible: () => state.amIVisible,
	getText: () => state.text,
	getResults: (tab) => state.results[tab]?.programmes as IProgrammeResult<IProgrammeCard>[] || [],
	getTotalHits: (tab) => state.results[tab]?.hitsTotal || 0,
	getHitsRelation: (tab) => state.results[tab]?.hitsTotalRelation,
	getTabs: () => {
		const isThereAnyExclusiveTab = state.tabs.some((tab) => tab.exclusive);

		if (isThereAnyExclusiveTab) {
			const selectedTab = state.tabs.find((tab) => tab.id === state.selectedTab);

			if (selectedTab?.exclusive) {
				return [selectedTab];
			}
		}

		return state.tabs.filter((tab) => !tab.exclusive);
	},
	getSelectedTab: () => state.selectedTab,
	getUserCurrency: () => state.userData?.currency || '',
	getUserNationality: () => state.userData?.nationality || 0,
	getUserCountryOfResidence: () => state.userData?.countryOfResidence || 0,
	getFacets: (key) => state.facets?.[key] || [],
	isGAIQuestionnaireTaken: () => state.isGAIQuestionnaireTaken,
	areDependenciesReady: () => state.dependenciesReady,
	getProgrammeSearchInput: () => state.programmeSearchInput,
	getFilterProvider: () => state.filterProvider,
	getSuggestions: () => state.suggestions,
	getUserKeyboardEvent: () => state.userKeyboardEvent,
};

export default getters;